const state = {
    toplistQuery: {
      category_id: [],
      start_date: "",
      end_date: "",
      site_id: [],
      columns: ["published_at","site_name","title","episode_number","season_number","title_length_formatted","category_name"],
      filters: 
      {
        measured_days: {from: null, to: null},
        title_length: {from: null, to: null},
        total_contacts: {from: null, to: null},
        total_online_rating: {from: null, to: null},
        tv_rating: {from: null, to: null}
      },
      measures: [],
      selectedPeriod: "consumptionperiod",
      sort_by: "measure_1",
      sort_direction: "DESC",
      publishedToDate: "", 
      title_search: "",
      start_value: "",
    },
    toplistQueryResult: {
    },
    toplistResults: {
      status: "NOT_LOADED"
    },
    toplistFields: [],
  };
  const getters = {  
    getToplistQuery: state => state.toplistQuery,
    getToplistQueryResult: state => state.toplistQueryResult,
    getToplistResults: state => state.toplistResults,
    getToplistFields: state => state.toplistFields,    
  };
  const mutations = {
    setToplistQuery: (state, payload) => { state.toplistQuery = payload  }, 
    setToplistQueryResult: (state, payload) =>
      state.toplistQueryResult = payload,
    setToplistResult: (state, payload) => state.toplistResults = payload,
    setToplistFields: (state, payload) => state.toplistFields = payload,
  };
  export default {
    state,
    getters,
    mutations
  };
  